<template>
  <div>
    <Form ref="goodsForm" :rules="ruleValidate" :model="goodsInfo" :label-width="120">
      <div class="title">基本信息</div>
      <FormItem label="商品" prop="goods_id">
        <Button
          type="default"
          icon="ios-add"
          @click="showSelectShopModal=true"
        >选择{{type==1?"课程":"图书"}}</Button>
        <span class="m-15" v-if="selectItem">已选：{{selectItem.title||selectItem.name}}</span>
      </FormItem>
      <FormItem label="商品简介" prop="intro">
        <UEditor v-model="goodsInfo.intro"></UEditor>
      </FormItem>
      <div class="title">上架信息</div>
      <FormItem label="兑换价格" prop="exchange_price">
        <InputNumber :min="1" :precision="0" v-model="goodsInfo.exchange_price"></InputNumber>
        <span>积分</span>
      </FormItem>
      <FormItem label="库存" prop="stock">
        <InputNumber :min="1" :precision="0" v-model="goodsInfo.stock"></InputNumber>
      </FormItem>
      <FormItem v-if="type==2" label="兑换限制" prop="limit_buy_num">
        <span>每个学员最多可兑换</span>
        <InputNumber :min="1" :precision="0" v-model="goodsInfo.limit_buy_num"></InputNumber>
        <span>个</span>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name:'IntegralStore'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          :loading="loading"
          @click="submitForm('goodsForm')"
        >保存并返回</Button>
      </FormItem>
    </Form>
    <Modal class="grid-select" v-model="showSelectShopModal" title="选择商品" width="900px">
      <CourseSelect
        ref="courseSelect"
        v-if="showSelectShopModal&&type==1"
        class="course-select"
        selectType="single"
        :selectedItems="courses"
        showCatagory
        :showStatus="false"
        :status="1"
        showPrice
        :exceptTypes="['3']"
        :integralShop="1"
      ></CourseSelect>
      <BookSelect
        ref="bookSelect"
        v-if="showSelectShopModal&&type==2"
        selectType="single"
        :selectedItems="books"
        showCatagory
        :showStatus="false"
        :status="1"
        showPrice
        :integralShop="1"
      ></BookSelect>
      <template v-slot:footer>
        <Button type="default" @click="showSelectShopModal=false">取消</Button>
        <Button type="primary" @click="confirmSelectShop">确定</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import UEditor from "@/components/UEditor.vue";
import CourseSelect from "@/components/GridSelect/CourseSelect.vue";
import BookSelect from "@/components/GridSelect/BookSelect.vue";
export default {
  name: "IntegralGoodsEdit",
  components: {
    CourseSelect,
    BookSelect,
    UEditor
  },
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      goodsInfo: {
        goods_id: "",
        goods_type: this.$route.query.type,
        intro: "",
        exchange_price: 1,
        stock: 1,
        limit_buy_num: 1
      },
      ruleValidate: {
        goods_id: [
          {
            required: true,
            type: "number",
            message: "商品不能为空",
            trigger: "change"
          }
        ],
        intro: [
          {
            required: true,
            message: "商品简介不能为空",
            trigger: "change"
          }
        ],
        exchange_price: [
          {
            required: true,
            type: "number",
            message: "兑换价格不能为空",
            trigger: "change"
          }
        ],
        stock: [
          {
            required: true,
            type: "number",
            message: "库存不能为空",
            trigger: "change"
          }
        ],
        limit_buy_num: [
          {
            required: true,
            type: "number",
            message: "兑换限制不能为空",
            trigger: "change"
          }
        ]
      },
      selectItem: null,
      courses: [],
      books: [],
      showSelectShopModal: false,
      loading: false
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    confirmSelectShop() {
      if (this.type == 1) {
        let list = this.$refs.courseSelect.getSelectList();
        if (list.length == 0) {
          this.$Message.info("请选择课程");
          return;
        }
        this.courses = list;
        this.selectItem = list[0];
      } else {
        let list = this.$refs.bookSelect.getSelectList();
        if (list.length == 0) {
          this.$Message.info("请选择图书");
          return;
        }
        this.books = list;
        this.selectItem = list[0];
      }
      this.goodsInfo.goods_id = this.selectItem.id;
      this.showSelectShopModal = false;
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = { ...this.goodsInfo };
        if (!this.id) {
          await this.$http.post("/api/integral/add", data, {
            onComplete: () => {
              this.loading = false;
            }
          });
        } else {
          await this.$http.put("/api/integral/update/" + this.id, data, {
            onComplete: () => {
              this.loading = false;
            }
          });
        }
        this.$router.push({ name: "IntegralStore" });
      });
    },
    async getData() {
      if (!this.id) {
        return;
      }
      let data = await this.$http.get("/api/integral/detail/" + this.id);
      this.$pub.autoMapper(data, this.goodsInfo);
      this.selectItem = { name: data.name };
      if (this.type == 1) {
        this.courses = [{ id: data.goods_id }];
      } else {
        this.books = [{ id: data.goods_id }];
      }
    }
  }
};
</script>